import { render } from "./DisplayData.vue?vue&type=template&id=6a2e8166&scoped=true"
import script from "./DisplayData.vue?vue&type=script&lang=js"
export * from "./DisplayData.vue?vue&type=script&lang=js"

import "./DisplayData.vue?vue&type=style&index=0&id=6a2e8166&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a2e8166"

export default script